<template>
  <li class="message animate-fadeIn" :class="messageClasses">
    <app-avatar v-if="chatMessageDto.avatar" :id="chatMessageDto.avatar" :size="48" />
    <div class="message__group">

      <div v-if="chatMessageDto.IsImage()" class="message__bubble message__bubble--img" @click="showImage = true">
        <chat-message-image :chatMessageDto="chatMessageDto" />
      </div>

      <div v-else-if="chatMessageDto.IsAudio()" class="message__bubble message__bubble--audio">
        <chat-message-audio :chatMessageDto="chatMessageDto" />
      </div>

      <div v-else-if="chatMessageDto.IsText()" class="message__bubble message__bubble--text">{{chatMessageDto.text}}</div>

      <div v-else class="message__bubble error">[系統錯誤] 訊息發生未知問題</div>

      <span class="message__time">{{chatMessageDto.timeStamp | messageTime}}</span>
    </div>
  </li>
</template>

<script>
import {mapState} from 'vuex';
import moment from 'moment';

import ChatMessageAudio from './ChatMessageAudio';
import ChatMessageImage from './ChatMessageImage';

export default {
  components: {
    'chat-message-audio': ChatMessageAudio,
    'chat-message-image': ChatMessageImage
  },

  props: {
    chatMessageDto: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState({
      username: state => state.profile.username
    }),

    isSelf() {
      return this.chatMessageDto.speaker === this.username;
    },

    messageClasses() {
      let classes = [];
      if (this.isSelf) {
        classes.push('message--right');
      } else {
        classes.push('message--left');
      }

      return classes;
    }
  },

  filters: {
    messageTime(timestamp) {
      return moment(timestamp).format('A hh:mm');
    }
  },

  mounted() {}
};
</script>

<style lang="stylus" scoped>

$left-bubble-color = rgb(230, 230, 230);
$right-bubble-color = $secondary-color;

$bubble-arrow-size = 15px;
$bubble-arrow-top = 10px;

.message {
  list-style-type: none;
  display: flex;
  align-items: flex-start;
  flex-basis: auto;
  flex-shrink: 0;
  padding-bottom: 1rem;
  max-width: 80%;
}

.message--left {
  align-self: flex-start;

  .message__bubble {
    margin-left: ($bubble-arrow-size + 4);
    background-color: $left-bubble-color !important;
  }

  .message__bubble::after {
    border-right-color: $left-bubble-color;
    border-left: 0;
    border-top: 0;
    left: 0;
    transform: translateX(-($bubble-arrow-size));
  }
}

.message--right {
  align-self: flex-end;

  .message__avatar {
    order: 2;
  }

  .message__bubble {
    order: 1;
    margin-right: $bubble-arrow-size;
    background-color: $right-bubble-color !important;
  }

  .message__bubble::after {
    border-left-color: $right-bubble-color;
    border-right: 0;
    border-top: 0;
    right: 0;
    transform: translateX($bubble-arrow-size);
  }
}

.message__avatar {
  // top: -0.5rem;
}

.message__group {
  display: flex;
  padding-top: 8px;
  min-height: 43px;
}

.message__bubble {
  position: relative;
  border-radius: 5px;
  padding: 0.5rem;
  align-items: center;
  display: flex;
}

.message__bubble::after{
  content: '';
  position: absolute;
  top: $bubble-arrow-top;
  width: 0;
  height: 0;
  border: $bubble-arrow-size solid transparent;
}

// hide bubble arrow
.message__bubble--img.message__bubble::after,
.message__bubble--audio.message__bubble::after {
  display: none;
}

.message__bubble--text {
  white-space: pre-wrap;
}

.message__bubble--img,
.message__bubble--audio {
  padding: 0;
  background-color: transparent !important;
}

.message__time {
  font-size: 0.8em;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  white-space: nowrap;
  align-self: flex-end;
}


.animate-fadeIn {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-iteration-count: 1;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
